import { useEffect, useState } from "react"
import { IMChatMsg } from "../models/app/IMChatMsg"
import { rootStore } from "../StApp"



export const IMChatComp = (props:{chat: IMChatMsg})=>{

    // const [voiceUrl, setVoiceUrl] = useState<string|undefined>('')
    // useEffect(()=>{

    //     async function act(){
    //         let voiceUrl = await fetchVNoteAudioUrl(props.chatId, props.chatMsg.voice!)
    //         setVoiceUrl(voiceUrl)

    //     }

    //     if(props.chatMsg.voice)
    //      act()
    //     else if(props.chatMsg.voiceLocalUrl)
    //      setVoiceUrl(props.chatMsg.voiceLocalUrl) 
        
    // },[])

    const userAlignStyle = 'chat-row chat-user'
    const recepAlignStyle = 'chat-row chat-recep'
    const userStyle = 'chat-item-user'
    const recepStyle = 'chat-item-recep'


    return(
        <div className={props.chat.senderUid == rootStore.mainStore.uid? userAlignStyle: recepAlignStyle} >
            <div className={props.chat.senderUid == rootStore.mainStore.uid? userStyle: recepStyle}>
                <p className='chat-text' >{props.chat.data}</p>
                <div style={{height: 10}} ></div>
                <div className='flex-row center-align ' style={{justifyContent: 'space-between'}} >
                    {/* <AudioPlayer voiceUrl={voiceUrl} /> */}
                    <div style={{width: 10}} ></div>
                    <p className='chat-date' >{props.chat.time} <br />{props.chat.dateOfSending}</p>
                </div>
            </div>
        </div>
    )
}